import Stars from "@/components/site/Stars";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black text-white border-t border-white/10 px-6 md:px-10 pt-20 pb-10 overflow-hidden"
    >
      {/* Faint stars */}
      <div aria-hidden className="absolute inset-0 opacity-60">
        <Stars density={0.7} drift={0.006} twinkle={false} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <div className="x-mark text-6xl md:text-8xl leading-none">X</div>
            <p className="mt-6 text-white/60 text-sm max-w-xs leading-relaxed">
              R.I.V.H<sup className="text-[0.55em] align-super">™</sup> —
              Real. Intelligent. Valuable. Humans. A room, in the shape of a
              garment, in the shape of the sky.
            </p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-white/80">
              Find your purpose.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              House
            </div>
            <ul className="space-y-2 text-sm">
              {["Capsule 01", "Manifesto", "Showroom", "Register"].map((l) => (
                <li key={l}>
                  <span className="text-white/80 hover:text-white transition-colors cursor-default">
                    {l}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Signal
            </div>
            <ul className="space-y-2 text-sm">
              <li className="text-white/80">Instagram</li>
              <li className="text-white/80">Are.na</li>
              <li className="text-white/80">Contact</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Orbit
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              By appointment only.
              <br />
              Among the stars.
            </p>
          </div>
        </div>

        <div className="mt-20 border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
          <span>
            © {new Date().getFullYear()} R.I.V.H
            <sup className="text-[0.65em] align-super">™</sup> — all rights
            reserved
          </span>
          <span>Made in shadow. Sold among stars.</span>
        </div>
      </div>
    </footer>
  );
}
